import React, { useState } from "react";
import { useSelector } from "react-redux";
import tokenStorage from "../../../services/tokenStorage";

import { Container, Grid } from "@mui/material";
import WelcomeCard from "../CMS/WelcomeCard";
import ExceptionsCard from "./Exceptions/ExceptionsCard";
import ClaimsCard from "./Claims/ClaimsCard";
import RosterCard from "./Roster/RosterCard";
import LoginCard from "../../Common/Card/LoginCard";
import BreadcrumbBuilder from ".//BreadcrumbBuilder";
import RSAvatar from "./RSAvatar";

import { getApplication } from "../../../reducers";

function Dashboard() {
    const [loginUrl, setLoginUrl] = useState(null);

    const app = useSelector((state) => getApplication(state, "Z-RS"));
    if (!!app && !loginUrl) {
        tokenStorage.getSSOToken(app.uuid).then((token) => {
            if (!!token) {
                const redirectRoute = encodeURIComponent("/welcome");
                setLoginUrl(
                    `${app.serviceURL}/sso?access_token=${token}&rd=${redirectRoute}`
                );
            }
        });
    }

    return (
        <Container className="content">
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <BreadcrumbBuilder />
                </Grid>

                <Grid item xs={12}>
                    <WelcomeCard appCode={"Z-RS"} />
                </Grid>
                <Grid item xs={12}>
                    <RosterCard />
                </Grid>
                <Grid item xs={6}>
                    <ClaimsCard />
                </Grid>
                <Grid item xs={6}>
                    <ExceptionsCard />
                </Grid>

                <Grid
                    item
                    sm={12}
                    md={6}
                    lg={6}
                    xl={4}
                    className="card-grid-item"
                >
                    <LoginCard
                        appName="Rostering"
                        avatar={<RSAvatar />}
                        loginURL={loginUrl}
                    />
                </Grid>
            </Grid>
        </Container>
    );
}
export default Dashboard;
